import React, { useState } from 'react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        setFormData({ name: '', email: '', message: '' });
    };

    const handleLinkClick = (e) => {
        e.preventDefault(); // Prevent the default anchor link behavior
        console.log('Link clicked!');
        // You can add any other logic you need here
    };

    return (
        <section id="contact" className="py-20 bg-gray-100">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">Get in Touch</h2>
                <div className="flex flex-wrap -mx-4">
                    <div className="w-full md:w-1/2 px-4 mb-8 md:mb-0">
                        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-md p-6">
                            <div className="mb-4">
                                <label htmlFor="name" className="block text-gray-700 font-semibold mb-2">Your Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-bilih-blue"
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">Your Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-bilih-blue"
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="message" className="block text-gray-700 font-semibold mb-2">Your Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="5"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-bilih-blue"
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="bg-bilih-blue text-white px-6 py-2 rounded-full hover:bg-bilih-green transition-colors duration-300">Send Message</button>
                        </form>
                    </div>
                    <div className="w-full md:w-1/2 px-4">
                        <div className="bg-white rounded-lg shadow-md p-6">
                            <h3 className="text-2xl font-semibold mb-4">Contact Information</h3>
                            <p className="flex items-center mb-4">
                                <i className="feather icon-map-pin mr-2 text-bilih-blue"></i>
                                123 Innovation Street, Tech City, TC 12345
                            </p>
                            <p className="flex items-center mb-4">
                                <i className="feather icon-phone mr-2 text-bilih-blue"></i>
                                +1 (555) 123-4567
                            </p>
                            <p className="flex items-center mb-4">
                                <i className="feather icon-mail mr-2 text-bilih-blue"></i>
                                info@bilih.com
                            </p>
                            <h4 className="text-xl font-semibold mt-8 mb-4">Follow Us</h4>
                            <div className="flex space-x-4">
                                <a href="#" onClick={handleLinkClick} className="text-gray-600 hover:text-bilih-blue transition-colors duration-300">
                                    <i className="fab fa-facebook fa-2x"></i>
                                </a>
                                <a href="#" onClick={handleLinkClick} className="text-gray-600 hover:text-bilih-blue transition-colors duration-300">
                                    <i className="fab fa-twitter fa-2x"></i>
                                </a>
                                <a href="#" onClick={handleLinkClick} className="text-gray-600 hover:text-bilih-blue transition-colors duration-300">
                                    <i className="fab fa-linkedin fa-2x"></i>
                                </a>
                                <a href="#" onClick={handleLinkClick} className="text-gray-600 hover:text-bilih-blue transition-colors duration-300">
                                    <i className="fab fa-instagram fa-2x"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
